module.exports = __webpack_public_path__ + "static/media/87.afe39b14.gif";